const {Component} = require("react");
const PropTypes = require("prop-types");
const {pluckKeysExcept} = require("app/util/object");
const {normalizeRestrictedInput} = require("app/util/text");

class RestrictedInput extends Component {

	static get propTypes() {
		return {
			tag: PropTypes.string,
			onInput: PropTypes.func
		};
	}

	static get defaultProps() {
		return {
			tag: "input"
		};
	}

	normalizeValue(value) {
		return normalizeRestrictedInput(value);
	}

	onInput = (e) => {
		this.inputElement.value = this.normalizeValue(this.inputElement.value);

		if (typeof this.props.onInput === "function") {
			this.props.onInput(e);
		}
	};

	get value() {
		return this.inputElement ? this.inputElement.value : "";
	}

	set value(value) {
		if (this.inputElement) {
			this.inputElement.value = this.normalizeValue(value);
		}
	}

	render() {
		const props = pluckKeysExcept(this.props, ["onInput", "tag", "key"]);
		const Tag = this.props.tag;

		return (
			<Tag ref={el => this.inputElement = el} {...props} onInput={this.onInput}/>
		);
	}

}

module.exports = RestrictedInput;